import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, Button, Grid, Modal, Paper, Typography } from "@mui/material";
import RtlProvider from "../../../Components/RtlProvider";

import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import staticVariablesApi from "../../../api/staticVariablesApi";
import helper from "../../../helper";
import hotelStructureApi from "../../../api/hotelStructureApi";
import { NavLink, useParams } from "react-router-dom";
import { MdAdd, MdCheck } from "react-icons/md";
import { HiXMark } from "react-icons/hi2";
import hotelApi from "../../../api/hotelApi";
import AddStructureForm from "./AddStructureForm";
import DeleteHotelStructureForm from "./DeleteHotelStructureForm";



const HotelStructureList = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  // const [rows, setRows] = useState([]);
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);
  const { id } = useParams();
  const [hotelInfo, setHotelInfo] = useState(null)
  const [selectedStructure, setSelectedStructure] = useState(null)
  useEffect(() => {

    hotelApi.GetByKey(id)
      .then(res => {
        setHotelInfo(res.data.data)
      })
      .catch(err => console.log(err));

    GetData();
  }, [refresh]);
  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
    handleCloseAddStructureModal()
  }

  const GetData = () => {
    setLoadingRows(true);
    hotelStructureApi.GetStructureByHotelId(id)
      .then((res) => {
        setData(res.data.data)
      })
      .catch((error) => console.log(error))
      .finally(() => setLoadingRows(false));


  };


  const columns = useMemo(
    () => [
      {
        accessorKey: 'code',
        header: 'کد',
        size: 100,
      },

      {
        accessorKey: 'isDefault',
        header: 'ساختار پیش فرض',
        Cell: ({ cell, row }) => (
          row.original.isDefault ? <MdCheck size={25} color='green' /> : <HiXMark />
        ),
      }


    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: {
      sorting: [

      ],
    },
    state: {
      isLoading: loadingRows,
    },
    enableRowSelection: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enablePagination: false,
    enableSorting: true,
    enableColumnActions: false,

    mrtTheme: (theme) => ({
      baseBackgroundColor: theme.palette.background.default, //change default background color
    }),

    muiTableProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',

      },
    },
    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        backgroundColor: '#86A7FC',
        fontWeight: 'bold',
        textAlign: 'left'
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(81, 81, 81, .5)',
        textAlign: 'left'
      },
    },
    enableRowActions: true,
    positionActionsColumn: 'last',
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: '', //change header text
        size: 300, //make actions column wider

      },
    },
    renderRowActions: ({ row, table }) => (

      <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>

        {
          AccessControl.checkPermissions(userPermissions, ["Hotel:Delete"]) &&
          <DeleteHotelStructureForm id={row.original.id} refreshGrid={RefreshGrid} />
        }
      </Box>
    ),
  });


  //افزودن
  const [openAddStructureModal, setOpenAddStructureModal] = useState(false);
  const handleOpenAddStructureModal = (row) => {
    setSelectedStructure(row)
    setOpenAddStructureModal(true);
  };
  const handleCloseAddStructureModal = () => {
    setSelectedStructure(null)
    setOpenAddStructureModal(false);
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    m: 10
  };
  return (
    <RtlProvider>

      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Button variant="contained"
          component={NavLink} to={`/dashboard/HotelPanel`} color="primary" style={{ marginBottom: 10 }}>بازگشت</Button>
      </Grid>
      <Typography component="h1" variant="h5" mb={2}>
        لیست ساختارهای هتل {hotelInfo?.name}
      </Typography>
      <Box mb={2}>
        {AccessControl.checkPermissions(userPermissions, ["HotelStructure:Add"]) && <Button variant="contained" onClick={() => {
          handleOpenAddStructureModal()
        }}
          color="secondary" sx={{ whiteSpace: 'nowrap' }} startIcon={<MdAdd />}>
          افزودن
        </Button>
        }
      </Box>
      <MaterialReactTable table={table} />
      <Modal
        keepMounted
        open={openAddStructureModal}
        onClose={handleCloseAddStructureModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            افزودن ساختار هتل
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 4 }}>
            {<AddStructureForm id={id} refreshGrid={RefreshGrid} />}
          </Typography>
        </Box>
      </Modal>
    </RtlProvider>

  );
}

export default HotelStructureList;
